import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=c4b32d86&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b32d86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4b32d86')) {
      api.createRecord('c4b32d86', component.options)
    } else {
      api.reload('c4b32d86', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=c4b32d86&scoped=true&", function () {
      api.rerender('c4b32d86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/edit.vue"
export default component.exports